module.exports = __webpack_public_path__ + "assets/img/Alicia_Landsverk_PHD-LSCSW.e51388c9.jpg";